import { CategoricalDonut } from '../../Common/Charts/CategoricalDonut';
import { useFinancingChartsDataContext } from './hooks/useFinancingChartsDataContext';
import { coresMescladasArray } from '../../Common/styles/colors';

export const FinancingBySource = () => {
    const { chartData } = useFinancingChartsDataContext();

    const porFonte = chartData?.bySource || [];
    const subtitles = porFonte.map((item) => item.descricao);
    const values = porFonte.map((item) => item.total);
    const colors = subtitles.map((_, index) => coresMescladasArray[index % coresMescladasArray.length]);

    return (
        <CategoricalDonut
            title={'Distribuição por Fonte de Pagamento'}
            values={values}
            subtitles={subtitles}
            colors={colors}
        />
    );
};
